// extracted by mini-css-extract-plugin
export default {"area":"Financial_area__0dETC"};